'use client';

import ImageOptimizer from '@/components/image-optimizer';
import { cn } from '@/lib/utils';
import { useState } from 'react';

interface Props {
  images: string[];
  className?: string;
}

const BranchImageGallery = ({ images, className }: Props) => {
  const [selected, setSelected] = useState(0);

  if (!images || images.length === 0) {
    return null;
  }

  // 썸네일은 최대 4개만 표시
  const thumbnailImages = images.slice(0, 4);

  return (
    <div className={cn('space-y-3', className)}>
      {/* 1) 메인 이미지 */}
      <div className="desktop:h-[320px] desktop:w-[504px] relative aspect-[327/207] w-full overflow-hidden rounded-xl">
        <ImageOptimizer
          src={images[selected]}
          alt={`Branch image ${selected + 1}`}
          fill
          className="w-full object-cover"
        />
      </div>

      {/* 2) 썸네일 리스트 (최대 4개) */}
      <div className="grid grid-cols-4 gap-2 overflow-x-auto pb-1">
        {thumbnailImages.map((src, idx) => (
          <button
            key={idx}
            onClick={() => setSelected(idx)}
            className="desktop:h-[120px] desktop:w-[120px] relative aspect-square overflow-hidden rounded-xl"
          >
            <ImageOptimizer
              src={src}
              alt={`Thumbnail ${idx + 1}`}
              fill
              className="w-full object-cover"
            />
            {/* 선택된 썸네일에만 검정 60% 오버레이 */}
            {selected === idx && (
              <div className="absolute inset-0 bg-black/60" />
            )}
          </button>
        ))}
      </div>
    </div>
  );
};

export default BranchImageGallery;
